<!-- Particles background -->
<ngx-particles
  id="coinflip-won-modal-new-particles"
  class="particles-container"
  [options]="particlesOptions"
/>

<!-- Close button -->
<button class="close-button" (click)="modalService.close()">
  <svg-icon src="assets/icons/core/close.svg" />
</button>

<!-- Winner avatar section -->
<div class="winner-section">
  <div class="avatar-wrapper">
    <img
      class="winner-avatar"
      [src]="winnerAvatar()"
      alt="Winner avatar"
    />
    <div class="crown-badge">
      <div class="crown-badge__bg"></div>
      <svg-icon src="assets/icons/games/king.svg" />
    </div>
  </div>

  <h1 class="title">Congratulations!</h1>
  <p class="subtitle">
    You won
    <app-cost [cost]="totalValue()" [balanceType]="'skins'" [gap]="4" />
    with <span class="chance">{{ winnerChance() }}%</span> chance
  </p>
</div>

<!-- Skins grid using existing skins-list component -->
<div class="skins-grid-wrapper">
  <app-skins-list
    [skins]="skins()"
    [(selectedSkins)]="selectedSkins"
    [selectable]="true"
    [config]="{
      columns: 4,
      skin_min_width: '120px',
      mobile: {
        skin_min_width: '90px',
        padding: '4px'
      }
    }"
    [balanceType]="'skins'"
  />
</div>

<!-- Bottom bar -->
<div class="bottom-bar">
  <div class="selection-info">
    <app-cost [cost]="selectedValue()" [balanceType]="'skins'" [gap]="4" />
    <span class="items-count">{{ selectedCount() }}/{{ totalCount() }} items selected</span>
  </div>

  <app-checkbox
    [checked]="selectAll()"
    (checkedChange)="onSelectAllChange($event)"
  >
    Select All
  </app-checkbox>
</div>

<!-- Action buttons -->
<div class="action-buttons">
  <button
    class="button button--style-yellow h-44 padding-x-24"
    (click)="instantDeposit()"
  >
    Instant Deposit
  </button>
  <button
    class="button button--style-blue h-44 padding-x-24"
    (click)="withdrawEverything()"
  >
    Withdraw Everything in: {{ countdownDuration() }}
  </button>
</div>
